export default "__VITE_ASSET__DsRGUs2z__"